import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';

@Injectable({
	providedIn: 'root',
})
export class BrokerageSearchDispatch {
	@Dispatch()
	Search = (searchTerm: string): actions.Search =>
		new actions.Search(searchTerm);

	@Dispatch()
	resetSearch = (): actions.Reset => new actions.Reset();
}
